
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import { getStatistics, serviceStatisticsListExport } from '../../api/statistics';
import { IPagination } from '@/types';
import VueRouter from 'vue-router';

@Component({
  name: 'StatisticsServicerDetails',
  components: {
  }
})
export default class extends Vue {
  private formSearch = {
    timePeriods: []
  }
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 1,
    total: 0
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private orderParams = {
    user_id: UserModule.getUserId,
    company_id: UserModule.getCompanyId,
    page: 1,
    size: 10
  }
  @Watch('orderParams', { deep: true, immediate: true })
  onParamsChange() {
    // 不在乎哪个变了，只要变了，就要重新请求数据
    this.getList();
  }
  handleCurrentChange(size:number) {
    this.orderParams.page = size;
  }

  handlePageSizeChange(size: number) {
    this.orderParams.size = size;
  }

  handleDetails(row: any) {
    this.$router.push({
      path: 'details',
      query: {
        branch_company_id: row.customer_company_id,
        servicer_company_id: row.servicer_company_id
      }
    });
  }

  branchStat(row: any) {
    /**
     * 点击分支机构后，需要在路由中增加一条信息
     * 在返回的时候，可以返回到上一级的列表中
     */
    this.$router.push({
      path: this.$route.path,
      query: {
        branch_company_id: row.customer_company_id,
        servicer_company_id: row.servicer_company_id
      }
    });
  }

  @Watch('$route', {
    deep: true
  })handleQueryChange() {
    /**
     * watch路由的变化，主要是在push和返回上一页的时候
     * 根据query去重新获取数据
     */
    this.getList();
  }

  // 导出Excel
  handleExport() {
    let startTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[0]) / 1000 : '';
    let endTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[1]) / 1000 : '';
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      cid: UserModule.getCompanyId,
      user_name: UserModule.getUserName,
      company_name: UserModule.getCompanyName,
      sid: this.$route.query.servicer_company_id,
      branch_id: this.$route.query.branch_company_id,
      start_time: isNaN(startTime) ? '' : startTime,
      end_time: isNaN(endTime) ? '' : endTime
    };
    serviceStatisticsListExport(pamars).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      let msg = err.msg;
    });
  }

  created() {
    this.getList();
  }
  private loading = false
  private tableData = []
  getList() {
    /**
     * @apiParam {Number} user_id 用户id
     * @apiParam {Number} company_id 公司id
     * @apiParam {Number} branch_company_id 分公司id
     * @apiParam {Number} start_time 开始时间
     * @apiParam {Number} end_time 结束时间
     * @apiParam {Number} cid 点击查询的那条公司id
     * @apiParam {Number} sid 点击查询的那条服务方id
     */
    const startTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[0]) / 1000 : '';
    const endTime: any = this.formSearch.timePeriods ? Date.parse(this.formSearch.timePeriods[1]) / 1000 : '';
    const params = {
      ...this.orderParams,
      servicer_company_id: this.$route.query.servicer_company_id,
      branch_id: this.$route.query.branch_company_id,
      start_time: isNaN(startTime) ? '' : startTime,
      end_time: isNaN(endTime) ? '' : endTime
    };
    this.loading = true;
    getStatistics(params).then(res => {
      if (res && res.data) {
        this.tableData = res.data.list;
      }
      this.loading = false;
    }).catch(err => {
      this.showErrorMsg(err.msg);
      this.loading = false;
    });
  }
  handleSearch() {
    this.getList();
  }

  handleClear() {
    this.formSearch = {
      timePeriods: []
    };
    this.pagination.currentPage = 1;
    this.pagination.total = 0;
    this.getList();
  }

  private dialogOrderDetailVisible = false
  private detail = {}
  getOrderDetail(val: any) {
    this.dialogOrderDetailVisible = true;
    this.detail = val;
  }

  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
